<template>
  <MainLayout>
		<div class="container">
      <!-- Show preview validation, errors -->
      <div class="box">
        <!-- Head -->
        <b-row>
					<b-col>
						<h2 class="inline-heading">Importar Reseñas</h2>
					</b-col>
          <b-overlay :show="loading" no-wrap rounded></b-overlay>
          <b-col class="col-md-6">
            <b-form-group class="d-flex justify-content-end">
                <b-button 
                  class="mr-2 btn-success" 
                  :href="downloadFormatURL" 
                  target="_blank">
                  <md-icon icon="download"/> Descargar formato</b-button>
            </b-form-group>
          </b-col>
				</b-row>
        <hr/>
        <b-row>
          <b-form-group label="Archivo .xlsx" class="col-md-4">
            <input type="file" id="file" ref="file" @change="handleFileUpload()"/>
          </b-form-group>
          <b-form-group class="pt-2">
            <b-button variant="dark" class="mt-3" @click="submitFile()">
              <md-icon icon="check"/> Validar reseñas
            </b-button>
          </b-form-group>
        </b-row>
        <!-- End Head -->

        <!-- Show error list -->
        <label class="text-danger" v-if="corrections">Errores encontrados</label>
        <ul v-if="message != ''">
          <li>{{ message }}</li>
        </ul>

        <!-- Errors table -->
        <b-table 
          v-if="errors.length"
          striped 
          hover 
          small 
          bordered 
          responsive 
          :items="errors"
          ref="table"
          show-empty empty-text="No se encontraron datos">

            <!-- A custom formatted column -->
            <template #cell(errores)="data">
              <ul>
                <li v-for="(error, index) in data.value" :key="index">
                  <small>{{ error }}</small>
                </li>
              </ul>
            </template>
            <!-- End custom formatted column -->
        </b-table>

        <!-- End errors table -->
			</div>
      <!-- End show preview validation, errors -->
      <br>
      <div class="box">
        <section id="success" v-if="reviewsCreated.length > 0">
          <b-button variant="outline-primary" size="lg" @click="reviewsCreated=[]">
            <md-icon icon="arrow_back"></md-icon> Continuar Importando Reseñas
          </b-button>
          <b-alert show variant="success" dismissible class="text-center mt-2">
            <b>Se guardaron correctamente las reseñas</b>
          </b-alert>

					<b-table 
            striped 
            hover 
            small
            bordered 
            responsive 
            :items="reviewsCreated" 
            class="text-nowrap borderless mt-3" 
            ref="table-reservations-created"
						show-empty 
            empty-text="No se encontraron datos" 
            :tbody-tr-class="rowClass">
					</b-table>
				</section>

				<section v-else>
					<b-row>
						<b-col md class="mb-2">
							<div class="mr-4">
								<span>{{rowsMessage}}</span>
								<b-form-select 
                  size="sm" 
                  class="ml-2" 
                  id="perPageSelector" 
                  v-model="perPage" 
                  :options="perPageOptions" 
                  @change="submitFile(false)">
                </b-form-select>
							</div>
						</b-col>
						<b-col md class="text-right">
							<b-row no-gutters>
								<b-col >
									<b-pagination 
                    v-model="currentPage" 
                    align="right" 
                    :total-rows="totalRows" 
                    :per-page="perPage" 
                    @input="submitFile(false)"/>
								</b-col>
							</b-row>
						</b-col>
					</b-row>

					<b-table 
            striped 
            hover 
            small 
            bordered 
            responsive 
            :items="items" 
            class="text-nowrap borderless" 
            ref="table"
						show-empty 
            empty-text="No se encontraron datos"
            :tbody-tr-class="rowClass">
					</b-table>

					<div class="d-flex justify-content-end">
						<b-button v-if="mapping" variant="dark" class="mr-2" @click="submitFileMap()">
              <md-icon icon="library_add"/> Guardar reseñas
            </b-button>
					</div>
				</section>
      </div>
    </div>
  </MainLayout>
</template>

<script>
  import MainLayout from '../layout/MainLayout.vue';

  export default {
    components: { MainLayout },
      props: {
        showSelectAll: {
          type : Boolean,
          required: false,
          default : false
        },
        model: {
          type: Array,
          required: false,
        },
        valueType: [String, Object]
      },
      data() {
        return {
          file: '',
          importResult: '',
          loading:false,
          items:[],
          perPage:50,
          currentPage:1,
          totalRows:0,
          perPageOptions:[
            {value:10,text:10},
            {value:50,text:50},
            {value:100,text:100},
            {value:200,text:200},
            {value:500,text:500},
            {value:1000,text:1000},
            {value:10000,text:10000},
          ],
          selectAll: false,
          selected:null,
          responses: [],
          errors: [],
          corrections: false,
          message: '',
          mapping: false,
          salesChannels: [],
          mappedServices: [],
          resSelected: {
            modalModelId: -1,
            tsSelectedId: -1,
            copyResId: -1,
            formTypeWork:"",
            show:false
          },
          reviewsCreated:[]
        }
      },
      computed:{
        offset() { 
          return (this.currentPage-1) * this.perPage 
        },
        rowsFrom() { 
          return this.offset+1
        },
        rowsTo() { 
          return Math.min(this.offset+this.perPage,this.totalRows) 
        },
        rowsMessage() {
          if (this.totalRows) {
            return "Mostrando : " + (((this.currentPage-1)*this.perPage)+1)  +" a "+Math.min((this.perPage*this.currentPage),this.totalRows) +" registros de "+this.totalRows;
          } else {
            return "Mostrando 0 de 0";
          }
        },
        downloadFormatURL() {
          return `${process.env.VUE_APP_API_URL}/reviews/downloadFormat`
        }
      },
      methods:{
        handleFileUpload() {
            this.file = this.$refs.file.files[0];
        },
        submitFile(reloadMapping = true) {
          this.loading         = true
          this.corrections     = false
          this.message         = false
          this.errors          = [];
          this.reviewsCreated  = [];

          let formData = new FormData();
          formData.append('file', this.file);
          formData.append('limit', this.perPage)
          formData.append('offset', this.offset)
          this.$root.api.post(`/reviews/import`,
            formData, {
              timeout: 1000 * 60 * 2, //2 minutes
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          ).then((res) => {

            this.importResult = res.data;
            this.loading      = false

            //Error reading file
            if (this.importResult.error) {

                this.mapping     = false
                this.corrections = true
                this.message     = this.importResult.message
                this.items       = []
                this.totalRows   = 0
                this.$root.showAlert('Error: ' + this.importResult.message, {variant:'danger'})
                console.log('error: ' + this.importResult.message)
                return false
            }

            this.errors    = this.importResult.data.errors
            this.items     = res.data.data.reviews
            this.totalRows = res.data.data.total_reviews
            this.selected  = 1

            //Not reload inputs
            if (!reloadMapping) return false
            if (Object.keys(this.importResult.data.errors).length > 0) {
              this.mapping     = false
              this.corrections = true
              this.$root.showAlert("Se encontraron errores", {variant:'warning'})
              return false
            } else {
              this.mapping = true
            }
            }).catch(error => {
                this.$root.handleRequestError(error)
                this.loading = false
            });
          },
          submitFileMap() {

            this.loading = true
            let formData = new FormData()
            formData.append('file', this.file)
            formData.append('confirmation', true)

            this.$root.api.post(`/reviews/import`, formData).then((res) => {
              this.corrections = false
              this.message     = false
              this.loading     = false

              if (res.data.error) {
                this.corrections = true
                this.message     = res.data.message
                this.$root.showAlert(res.data.message, {variant:'danger'})
                window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                return false
              }

              //Reload page
              this.$root.showAlert("Se registraron los reviews correctamente")
              this.reload()
              this.reviewsCreated     = res.data.data.reviews

            }).catch(error => {
                this.$root.handleRequestError(error)
                this.loading = false;
            })
          },
          updateTable(){
            this.$refs.table.refresh()
          },
          rowClass(item) {
            //Indicamos donde se encuentra el error dentro de los datos
            for (let error of this.errors) {
              if (item.index === error.index) return 'table-danger'
            }
          },
          reload() {
            this.mapping   = false
            this.items     = []
            this.totalRows = 0
            this.$refs.file.value = null
            this.responses = []
            this.file='';
          }
      }
  }
</script>

<style scoped>
	.active {
		color: cornflowerblue;
	}
	#perPageSelector{
		width: 80px
	}
</style>



